export const PRIVILEGES = {
  Requests: {
    /**
     * Viewing the list of requests
     */
    VIEW_LIST: { name: 'MODULE_REQUESTS_VIEW_LIST' },

    /**
     * Viewing request details
     */
    VIEW_DETAILS: { name: 'MODULE_REQUESTS_VIEW_DETAILS' },
    /**
     * Archiving requests
     */
    ARCHIVE: { name: 'MODULE_REQUESTS_ARCHIVE' },
    /**
     * Printing request
     */
    PRINT: { name: 'MODULE_REQUESTS_PRINT' },
  },

  Notifications: {
    /**
     * Displaying notifications about containers
     */
    VIEW_NOTIFICATIONS_CONTAINERS: { name: 'MODULE_NOTIFICATIONS_CONTAINERS' },

    /**
     * Displaying notifications about invoices
     */
    VIEW_NOTIFICATIONS_INVOICES: { name: 'MODULE_NOTIFICATIONS_INVOICES' },
    /**
     * Displaying notifications about carriers
     */
    VIEW_NOTIFICATIONS_CARRIERS: { name: 'MODULE_NOTIFICATIONS_CARRIERS' },
  },

  Offers: {
    /**
     * Viewing the list of offers
     */
    VIEW_OFFER_LIST: { name: 'MODULE_OFFERS_VIEW_OFFER_LIST' },
    /**
     * Creating an offer
     */
    CREATE_OFFER: { name: 'MODULE_OFFERS_CREATE_OFFER' },
    /**
     * View offer details
     */
    VIEW_OFFER_DETAILS: { name: 'MODULE_OFFERS_VIEW_OFFER_DETAILS' },
    /**
     * Edit offers
     */
    EDIT_OFFER: { name: 'MODULE_OFFERS_EDIT_OFFER' },
    /**
     * Edit own offers
     */
    EDIT_OFFER_OWNER: { name: 'MODULE_OFFERS_EDIT_OFFER_OWNER' },
    /**
     * Delete offers
     */
    DELETE_OFFER: { name: 'MODULE_OFFERS_DELETE_OFFER' },
    /**
     * Delete own offers
     */
    DELETE_OFFER_OWNER: { name: 'MODULE_OFFERS_DELETE_OFFER_OWNER' },
    /**
     * Add item to offer
     */
    ADD_OFFER_ITEM: { name: 'MODULE_OFFERS_ADD_OFFER_ITEM' },
    /**
     * Add item to own offers
     */
    ADD_OFFER_ITEM_OWNER: { name: 'MODULE_OFFERS_ADD_OFFER_ITEM_OWNER' },
    /**
     * Viewing item's details
     */
    VIEW_ITEM_DETAILS: { name: 'MODULE_OFFERS_VIEW_ITEM_DETAILS' },
    /**
     * Editing item's details
     */
    EDIT_ITEM_DETAILS: { name: 'MODULE_OFFERS_EDIT_ITEM_DETAILS' },
    /**
     * Editing own item's details
     */
    EDIT_ITEM_DETAILS_OWNER: { name: 'MODULE_OFFERS_EDIT_ITEM_DETAILS_OWNER' },
    /**
     * Copy offer
     */
    COPY_OFFER: { name: 'MODULE_OFFERS_COPY_OFFER' },
    /**
     * Copy own offer
     */
    COPY_OFFER_OWNER: { name: 'MODULE_OFFERS_COPY_OFFER_OWNER' },
    /**
     * Copy item
     */
    COPY_ITEM: { name: 'MODULE_OFFERS_COPY_ITEM' },
    /**
     * Copy own item
     */
    COPY_ITEM_OWNER: { name: 'MODULE_OFFERS_COPY_ITEM_OWNER' },
    /**
     * Publish an offer
     */
    PUBLISH_OFFER: { name: 'MODULE_OFFERS_PUBLISH_OFFER' },
    /**
     * Publish an own offer
     */
    PUBLISH_OFFER_OWNER: { name: 'MODULE_OFFERS_PUBLISH_OFFER_OWNER' },
    /**
     * Adding an annex to a published offer
     */
    ADD_ANEX_TO_OFFER: { name: 'MODULE_OFFERS_ADD_ANEX_TO_OFFER' },
    /**
     * Adding an annex to a published offer when earlier offer was used by him to make job based on it
     */
    ADD_ANEX_TO_OFFER_WHICH_RESULTED_IN_JOB: {
      name: 'MODULE_OFFERS_ADD_ANEX_TO_OFFER_WHICH_RESULTED_IN_JOB',
    },
    /**
     * Printing an offer
     */
    PRINT_OFFER: { name: 'MODULE_OFFERS_PRINT_OFFER' },
    /**
     * Mailing an offer
     */
    MAIL_OFFER: { name: 'MODULE_OFFERS_MAIL_OFFER' },
    /**
     * Mailing an own offer
     */
    MAIL_OFFER_OWNER: { name: 'MODULE_OFFERS_MAIL_OFFER_OWNER' },
    /**
     * Creating a job from offer
     */
    CREATE_JOB_FROM_OFFER: { name: 'MODULE_OFFERS_CREATE_JOB_FROM_OFFER' },
  },

  Orders: {
    /**
     * Viewing the list of orders
     */
    VIEW_ORDER_LIST: { name: 'MODULE_ORDERS_VIEW_ORDER_LIST' },
    /**
     * Viewing order's details
     */
    VIEW_ORDER_DETAILS: { name: 'MODULE_ORDERS_VIEW_ORDER_DETAILS' },
    /**
     * Printing order
     */
    PRINT_ORDER: { name: 'MODULE_ORDERS_PRINT_ORDER' },
    /**
     * Changing order status
     */
    CHANGE_ORDER_STATUS: { name: 'MODULE_ORDERS_CHANGE_ORDER_STATUS' },
    /**
     * Creating job from order
     */
    CREATE_JOB_FROM_ORDER: { name: 'MODULE_ORDERS_CREATE_JOB_FROM_ORDER' },
  },

  Jobs: {
    /**
     * Viewing the list of jobs
     */
    VIEW_JOB_LIST: { name: 'MODULE_JOBS_VIEW_JOB_LIST' },
    /**
     * Viewing job's details
     */
    VIEW_JOB_DETAILS: { name: 'MODULE_JOBS_VIEW_JOB_DETAILS' },
    /**
     * Editing a job
     */
    EDIT_JOB: { name: 'MODULE_JOBS_EDIT_JOB' },
    /**
     * Editing own job
     */
    EDIT_JOB_OWNER: { name: 'MODULE_JOBS_EDIT_JOB_OWNER' },
    /**
     * Deleting a job
     */
    DELETE_JOB: { name: 'MODULE_JOBS_DELETE_JOB' },
    /**
     * Deleting own job
     */
    DELETE_JOB_OWNER: { name: 'MODULE_JOBS_DELETE_JOB_OWNER' },
    /**
     * Adding an event
     */
    ADD_EVENT: { name: 'MODULE_JOBS_ADD_EVENT' },
    /**
     * Adding an own event
     */
    ADD_EVENT_OWNER: { name: 'MODULE_JOBS_ADD_EVENT_OWNER' },
    /**
     * Deleting an event
     */
    DELETE_EVENT: { name: 'MODULE_JOBS_DELETE_EVENT' },
    /**
     * Deleting an own event
     */
    DELETE_EVENT_OWNER: { name: 'MODULE_JOBS_DELETE_EVENT_OWNER' },
    /**
     * Adding a load
     */
    ADD_LOAD: { name: 'MODULE_JOBS_ADD_LOAD' },
    /**
     * Adding an load to own job
     */
    ADD_LOAD_OWNER: { name: 'MODULE_JOBS_ADD_LOAD_OWNER' },
    /**
     * Copying a load
     */
    COPY_LOAD: { name: 'MODULE_JOBS_COPY_LOAD' },
    /**
     * Copying an own load
     */
    COPY_LOAD_OWNER: { name: 'MODULE_JOBS_COPY_LOAD_OWNER' },
    /**
     * Deleting a load
     */
    DELETE_LOAD: { name: 'MODULE_JOBS_DELETE_LOAD' },
    /**
     * Deleting an load from own job
     */
    DELETE_LOAD_OWNER: { name: 'MODULE_JOBS_DELETE_LOAD_OWNER' },
    /**
     * Adding a service
     */
    ADD_SERVICE: { name: 'MODULE_JOBS_ADD_SERVICE' },
    /**
     * Adding a service to own job
     */
    ADD_SERVICE_OWNER: { name: 'MODULE_JOBS_ADD_SERVICE_OWNER' },
    /**
     * Copying a service
     */
    COPY_SERVICE: { name: 'MODULE_JOBS_COPY_SERVICE' },
    /**
     * Copying an own service
     */
    COPY_SERVICE_OWNER: { name: 'MODULE_JOBS_COPY_SERVICE_OWNER' },
    /**
     * Deleting a service
     */
    DELETE_SERVICE: { name: 'MODULE_JOBS_DELETE_SERVICE' },
    /**
     * Deleting an own service
     */
    DELETE_SERVICE_OWNER: { name: 'MODULE_JOBS_DELETE_SERVICE_OWNER' },
    /**
     * Generating/downloading documents
     */
    GENERATE_DOWNLOAD_DOCUMENTS: {
      name: 'MODULE_JOBS_GENERATE_DOWNLOAD_DOCUMENTS',
    },
    /**
     * Mailing documents
     */
    MAIL_DOCUMENTS: { name: 'MODULE_JOBS_MAIL_DOCUMENTS' },
    /**
     * Mailing own documents
     */
    MAIL_DOCUMENTS_OWNER: { name: 'MODULE_JOBS_MAIL_DOCUMENTS_OWNER' },
    /**
     * Sending an edi message
     */
    SEND_EDI_MESSAGE: { name: 'MODULE_JOBS_SEND_EDI_MESSAGE' },
    /**
     * Sending an edi VGM message
     */
    SEND_EDI_VGM_MESSAGE: { name: 'MODULE_JOBS_SEND_EDI_VGM_MESSAGE' },
    /**
     * Creating an invoice from job
     */
    CREATE_INVOICE_FROM_JOB: { name: 'MODULE_JOBS_CREATE_INVOICE_FROM_JOB' },
    /**
     * Adding a storehouse
     */
    ADD_STOREHOUSE: { name: 'MODULE_JOBS_ADD_STOREHOUSE' },
    /**
     * Viewing track and trace message details
     */
    VIEW_TRACK_AND_TRACE: { name: 'MODULE_JOBS_VIEW_TRACK_AND_TRACE' },

    /**
     * Can send container notification
     */
    SEND_CONTAINER_NOTIFICATION: {
      name: 'MODULE_JOBS_SEND_CONTAINER_NOTIFICATION',
    },

    /**
     * Can release detention status
     */
    RELEASE_DETENTION_STATUS: { name: 'MODULE_JOBS_RELEASE_DETENTION_STATUS' },
  },

  Invoices: {
    /**
     * Viewing the list of invoices
     */
    VIEW_INVOICE_LIST: { name: 'MODULE_INVOICES_VIEW_INVOICE_LIST' },
    /**
     * Creating an own invoice
     */
    CREATE_OWN_INVOICE: { name: 'MODULE_INVOICES_CREATE_OWN_INVOICE' },
    /**
     * Creating an administrative invoice
     */
    CREATE_ADMIN_INVOICE: { name: 'MODULE_INVOICES_CREATE_ADMIN_INVOICE' },
    /**
     * Adding a foreign invoice
     */
    ADD_FOREIGN_INVOICE: { name: 'MODULE_INVOICES_ADD_FOREIGN_INVOICE' },
    /**
     * Viewing an invoice's details
     */
    VIEW_INVOICE_DETAILS: { name: 'MODULE_INVOICES_VIEW_INVOICE_DETAILS' },
    /**
     * Deleting an own invoice
     */
    DELETE_OWN_INVOICE_OWNER: {
      name: 'MODULE_INVOICES_DELETE_OWN_INVOICE_OWNER',
    },
    /**
     * Deleting an own unpublished invoice
     */
    DELETE_OWN_INVOICE_UNPUBLISHED: {
      name: 'MODULE_INVOICES_DELETE_OWN_INVOICE_UNPUBLISHED',
    },
    /**
     * Deleting an foreign unpublished invoice
     */
    DELETE_FOREIGN_UNPUBLISHED: {
      name: 'MODULE_INVOICES_DELETE_FOREIGN_INVOICE_UNPUBLISHED',
    },
    /**
     * Deleting an administrative invoice
     */
    DELETE_ADMIN_INVOICE_OWNER: {
      name: 'MODULE_INVOICES_DELETE_ADMIN_INVOICE_OWNER',
    },
    /**
     * Deleting an administrative unpublished invoice
     */
    DELETE_ADMIN_INVOICE_UNPUBLISHED: {
      name: 'MODULE_INVOICES_DELETE_ADMIN_INVOICE_UNPUBLISHED',
    },
    /**
     * Printing an invoice
     */
    PRINT_INVOICE: { name: 'MODULE_INVOICES_PRINT_INVOICE' },
    /**
     * Publishing an own invoice
     */
    PUBLISH_OWN_INVOICE: { name: 'MODULE_INVOICES_PUBLISH_OWN_INVOICE' },
    /**
     * Publishing an own invoice created by user
     */
    PUBLISH_OWN_INVOICE_OWNER: {
      name: 'MODULE_INVOICES_PUBLISH_OWN_INVOICE_OWNER',
    },
    /**
     * Publishing a foreign invoice
     */
    PUBLISH_FOREIGN_INVOICE: {
      name: 'MODULE_INVOICES_PUBLISH_FOREIGN_INVOICE',
    },
    /**
     * Publishing an administrative invoice
     */
    PUBLISH_ADMIN_INVOICE: {
      name: 'MODULE_INVOICES_PUBLISH_ADMIN_INVOICE',
      spaceAfter: true,
    },
    /**
     * Publishing an administrative invoice created by user
     */
    PUBLISH_ADMIN_INVOICE_OWNER: {
      name: 'MODULE_INVOICES_PUBLISH_ADMIN_INVOICE_OWNER',
    },
    /**
     * Edit own invoice
     */
    EDIT_OWN_INVOICE: { name: 'MODULE_INVOICES_EDIT_OWN_INVOICE' },
    /**
     * Edit own invoice created by user
     */
    EDIT_OWN_INVOICE_OWNER: { name: 'MODULE_INVOICES_EDIT_OWN_INVOICE_OWNER' },
    /**
     * Edit foreign invoice
     */
    EDIT_FOREIGN_INVOICE: { name: 'MODULE_INVOICES_EDIT_FOREIGN_INVOICE' },
    /**
     * Edit administrative invoice
     */
    EDIT_ADMIN_INVOICE: { name: 'MODULE_INVOICES_EDIT_ADMIN_INVOICE' },
    /**
     * Edit administrative invoice created by user
     */
    EDIT_ADMIN_INVOICE_OWNER: {
      name: 'MODULE_INVOICES_EDIT_ADMIN_INVOICE_OWNER',
    },
    /**
     * Adding allocations
     */
    ADD_ALLOCATION: { name: 'MODULE_INVOICES_ADD_ALLOCATION' },
    /**
     * Accepting/complaining/rejecting allocations
     */
    REVIEW_ALLOCATION: { name: 'MODULE_INVOICES_REVIEW_ALLOCATION' },
    /**
     * Deleting allocations
     */
    DELETE_ALLOCATION: {
      name: 'MODULE_INVOICES_DELETE_ALLOCATION',
      spaceAfter: true,
    },
    /**
     * Exporting the invoices
     */
    EXPORT_INVOICE: { name: 'MODULE_INVOICES_EXPORT_INVOICE' },
    /**
     * Settle of own invoices
     */
    SETTLE_OWN_INVOICE: { name: 'MODULE_INVOICES_SETTLE_OWN_INVOICE' },
    /**
     * Settle of own invoices created by user
     */
    SETTLE_OWN_INVOICE_OWNER: {
      name: 'MODULE_INVOICES_SETTLE_OWN_INVOICE_OWNER',
    },
    /**
     * Settle of foreign invoices
     */
    SETTLE_FOREIGN_INVOICE: { name: 'MODULE_INVOICES_SETTLE_FOREIGN_INVOICE' },
    /**
     * Settle of administrative invoices
     */
    SETTLE_ADMIN_INVOICE: { name: 'MODULE_INVOICES_SETTLE_ADMIN_INVOICE' },
    /**
     * Settle of administrative invoices created by user
     */
    SETTLE_ADMIN_INVOICE_OWNER: {
      name: 'MODULE_INVOICES_SETTLE_ADMIN_INVOICE_OWNER',
    },
    /**
     * Mailing an own invoice
     */
    MAIL_OWN_INVOICE: {
      name: 'MODULE_INVOICES_MAIL_OWN_INVOICE',
      spaceAfter: true,
    },
    /**
     * Mailing an own invoice created by user
     */
    MAIL_OWN_INVOICE_OWNER: { name: 'MODULE_INVOICES_MAIL_OWN_INVOICE_OWNER' },
    /**
     * Mailing a foreign invoice
     */
    MAIL_FOREIGN_INVOICE: { name: 'MODULE_INVOICES_MAIL_FOREIGN_INVOICE' },
    /**
     * Mailing an administrative invoice
     */
    MAIL_ADMIN_INVOICE: { name: 'MODULE_INVOICES_MAIL_ADMIN_INVOICE' },
    /**
     * Mailing an administrative invoice created by user
     */
    MAIL_ADMIN_INVOICE_OWNER: {
      name: 'MODULE_INVOICES_MAIL_ADMIN_INVOICE_OWNER',
    },
    /**
     * Allows creating corrective own invoice without selecting invoice from system
     */
    CREATE_OWN_CORRECTIVE_INVOICE_FOR_NON_SYSTEM_INVOICE: {
      name: 'MODULE_INVOICES_CREATE_OWN_CORRECTIVE_INVOICE_FOR_NON_SYSTEM_INVOICE',
    },
    /**
     * Importing foreign invoices from Saldeo
     */
    IMPORT_INVOICE: { name: 'MODULE_INVOICES_IMPORT_INVOICE' },
  },

  Reports: {
    /**
     * Viewing/printing the activity report
     */
    VIEW_ACTIVITY_REPORT: { name: 'MODULE_REPORTS_VIEW_ACTIVITY_REPORT' },
    /**
     * Viewing/printing the containers report
     */
    VIEW_CONTAINERS_REPORT: { name: 'MODULE_REPORTS_VIEW_CONTAINERS_REPORT' },
    /**
     * Viewing/printing the invoices report
     */
    VIEW_INVOICES_REPORT: { name: 'MODULE_REPORTS_VIEW_INVOICES_REPORT' },
    /**
     * Viewing/printing the offers report
     */
    VIEW_OFFERS_REPORT: { name: 'MODULE_REPORTS_VIEW_OFFERS_REPORT' },
    /**
     * Viewing/printing the jobs report
     */
    VIEW_JOB_REPORT: { name: 'MODULE_REPORTS_VIEW_JOB_REPORT' },
    /**
     * Viewing/printing the forecasts
     */
    VIEW_FORECAST: { name: 'MODULE_REPORTS_VIEW_FORECAST' },
    /**
     * Viewing ocean schedules
     */
    VIEW_OCEAN_SCHEDULES: { name: 'MODULE_REPORTS_VIEW_OCEAN_SCHEDULES' },
  },

  Counterparties: {
    /**
     * Creating a counterparty
     */
    CREATE_COUNTERPARTY: { name: 'MODULE_COUNTERPARTIES_CREATE_COUNTERPARTY' },
    /**
     * Deleting a counterparty
     */
    DELETE_COUBTERPARTY: { name: 'MODULE_COUNTERPARTIES_DELETE_COUNTERPARTY' },
    /**
     * Viewing a counterparty's details
     */
    VIEW_COUNTERPARTY_DETAILS: {
      name: 'MODULE_COUNTERPARTIES_VIEW_COUNTERPARTY_DETAILS',
    },
    /**
     * Editing counterparty's details
     */
    EDIT_COUNTERPARTY_DETAILS: {
      name: 'MODULE_COUNTERPARTIES_EDIT_COUNTERPARTY_DETAILS',
    },
    /**
     * Adding a function to counterparty
     */
    ADD_COUNTERPARTY_FUNCTION: {
      name: 'MODULE_COUNTERPARTIES_ADD_COUNTERPARTY_FUNCTION',
    },
    /**
     * Deleting a function from counterparty
     */
    DELETE_COUNTERPARTY_FUNCTION: {
      name: 'MODULE_COUNTERPARTIES_DELETE_COUNTERPARTY_FUNCTION',
    },
    /**
     * Managing bussines cards/accounts/lots/storages
     */
    MANAGE_ASSETS: { name: 'MODULE_COUNTERPARTIES_MANAGE_ASSETS' },
    /**
     * Managing truckers data
     */
    MANAGE_TRUCKERS: { name: 'MODULE_COUNTERPARTIES_MANAGE_TRUCKERS' },
    /**
     * Deleting a file
     */
    DELETE_FILE: { name: 'MODULE_COUNTERPARTIES_DELETE_FILE' },
    /**
     * Exporting counterparty's tables
     */
    EXPORT_COUNTERPARTIES: { name: 'MODULE_COUNTERPARTIES_EXPORT_TABLES' },
  },

  Tables: {
    /**
     * Adding/editing/deleting items in tables
     */
    MANAGE_TABLE_ITEM: { name: 'MODULE_TABLES_MANAGE_TABLE_ITEM' },
    /**
     * Adding/editing/deleting port items
     */
    MANAGE_PORT_ITEM: { name: 'MODULE_TABLES_MANAGE_PORT_ITEM' },
    /**
     * Exporting the tables
     */
    EXPORT_TABLES: { name: 'MODULE_TABLES_EXPORT_TABLES' },
  },

  Prices: {
    /**
     * Adding/editing/deleting items in prices
     */
    MANAGE_PRICE_ITEM: { name: 'MODULE_PRICES_MANAGE_PRICE_ITEM' },
    /**
     * Exporting the prices lists
     */
    EXPORT_PRICES: { name: 'MODULE_PRICES_EXPORT_PRICES' },
  },

  Admin: {
    /**
     * Viewing the list of groups
     */
    VIEW_GROUP_LIST: { name: 'MODULE_ADMIN_VIEW_GROUP_LIST' },
    /**
     * Viewing the group details
     */
    VIEW_GROUP_DETAILS: { name: 'MODULE_ADMIN_VIEW_GROUP_DETAILS' },
    /**
     * Adding/editing/deleting groups
     */
    MANAGE_GROUP: { name: 'MODULE_ADMIN_MANAGE_GROUP' },
    /**
     * Exporting the groups list
     */
    EXPORT_GROUP: { name: 'MODULE_ADMIN_EXPORT_GROUP' },
    /**
     * Viewing the list of branches
     */
    VIEW_BRANCHES_LIST: { name: 'MODULE_ADMIN_VIEW_BRANCHES_LIST' },
    /**
     * Viewing the branches details
     */
    VIEW_BRANCHES_DETAILS: { name: 'MODULE_ADMIN_VIEW_BRANCHES_DETAILS' },
    /**
     * Adding/editing/deleting branches
     */
    MANAGE_BRANCHES: { name: 'MODULE_ADMIN_MANAGE_BRANCHES' },
    /**
     * Exporting the branches list
     */
    EXPORT_BRANCHES: { name: 'MODULE_ADMIN_EXPORT_BRANCHES' },
    /**
     * Viewing the list of users
     */
    VIEW_USER_LIST: { name: 'MODULE_ADMIN_VIEW_USER_LIST' },
    /**
     * Viewing the user details
     */
    VIEW_USER_DETAILS: { name: 'MODULE_ADMIN_VIEW_USER_DETAILS' },
    /**
     * Adding/editing/deleting users
     */
    MANAGAE_USER: { name: 'MODULE_ADMIN_MANAGE_USER' },
    /**
     * Exporting the users list
     */
    EXPORT_USERS: { name: 'MODULE_ADMIN_EXPORT_USERS' },
    /**
     * Viewing the list of parameters
     */
    VIEW_PARAMETER_LIST: { name: 'MODULE_ADMIN_VIEW_PARAMETER_LIST' },
    /**
     * Viewing the parameters details
     */
    VIEW_PARAMETER_DETAILS: { name: 'MODULE_ADMIN_VIEW_PARAMETER_DETAILS' },
    /**
     * Adding/editing/deleting/reseting parameters
     */
    MANAGE_PARAMETER: { name: 'MODULE_ADMIN_MANAGE_PARAMETER' },
    /**
     * Exporting the parameters list
     */
    EXPORT_PARAMETERS: { name: 'MODULE_ADMIN_EXPORT_PARAMETERS' },
    /**
     *  Accessing/generating JPK
     */
    JPK: { name: 'MODULE_ADMIN_JPK' },
    /**
     * Accessing/modifying primary counterparty
     */
    VIEW_PRIMARY_COUNTERPARTY: { name: 'MODULE_ADMIN_PRIMARY_COUNTERPARTY' },
    /**
     * Viewing the list of roles
     */
    VIEW_ROLE_LIST: { name: 'MODULE_ADMIN_VIEW_ROLE_LIST' },
    /**
     * Viewing the role details
     */
    VIEW_ROLE_DETAILS: { name: 'MODULE_ADMIN_VIEW_ROLE_DETAILS' },
    /**
     * Adding/editing/deleting roles
     */
    MANAGE_ROLE: { name: 'MODULE_ADMIN_MANAGE_ROLE' },
    /**
     * Exporting the roles list
     */
    EXPORT_ROLE: { name: 'MODULE_ADMIN_EXPORT_ROLE' },
    /**
     * Viewing the list of service terms
     */
    VIEW_SERVICE_TERMS_LIST: { name: 'MODULE_ADMIN_VIEW_SERVICE_TERMS_LIST' },
    /**
     * Viewing the service terms details
     */
    VIEW_SERVICE_TERMS_DETAILS: {
      name: 'MODULE_ADMIN_VIEW_SERVICE_TERMS_DETAILS',
    },
    /**
     * Adding/editing/deleting service terms
     */
    MANAGE_SERVICE_TERMS: { name: 'MODULE_ADMIN_MANAGE_SERVICE_TERMS' },
    /**
     * Application monitoring
     */
    APP_MONITORING: { name: 'MODULE_ADMIN_MONITORING' },
  },

  Settings: {
    /**
     * Viewing the list of discriminants
     */
    VIEW_DISCRIMINANT_LIST: { name: 'MODULE_SETTINGS_VIEW_DISCRIMINANT_LIST' },
    /**
     * Viewing discriminant details
     */
    VIEW_DISCRIMINANT_DETAIL: {
      name: 'MODULE_SETTINGS_VIEW_DISCRIMINANT_DETAIL',
    },
    /**
     * Adding/editing/deleting discriminants
     */
    MANAGE_DISCRIMINANT: { name: 'MODULE_SETTINGS_MANAGE_DISCRIMINANT' },
  },

  UserAccountManagement: {
    /**
     * Viewing/editing data section
     */
    DATA_SECTION: { name: 'MODULE_UAM_DATA_SECTION' },
    /**
     * Viewing/editing replacements section
     */
    REPLACEMENT_SECTION: { name: 'MODULE_UAM_REPLACEMENT_SECTION' },
    /**
     * Viewing/editing password section
     */
    PASSWORD_SECTION: { name: 'MODULE_UAM_PASSWORD_SECTION' },
    /**
     * Viewing/editing email settings section
     */
    EMAIL_SECTION: { name: 'MODULE_UAM_EMAIL_SECTION' },
  },

  Calendar: {
    /**
     * Viewing/editing data section
     */
    MANAGE_CALENDAR: { name: 'MODULE_CALENDAR_MANAGE_CALENDAR' },
  },

  Client: {
    /**
     * Full access to client module
     */
    GENERAL: { name: 'MODULE_CLIENT_GENERAL' },
  },

  TransportCloud: {
    /**
     * Access to Transport Cloud view
     */
    VIEW_TRANSPORT_CLOUD_LIST: { name: 'MODULE_TRANSPORT_CLOUD_VIEW_LIST' },
    /**
     * Editing all Transport Cloud records
     */
    EDIT_RECORDS_ALL: { name: 'MODULE_TRANSPORT_CLOUD_EDIT_RECORDS_ALL' },
    /**
     * Editing own Transport Cloud records
     */
    EDIT_RECORDS_OWNER: { name: 'MODULE_TRANSPORT_CLOUD_EDIT_RECORDS_OWNER' },
    /**
     * Editing all Transport Cloud shipment plans
     */
    EDIT_SHIPMENT_PLANS_ALL: {
      name: 'MODULE_TRANSPORT_CLOUD_EDIT_SHIPMENT_PLANS_ALL',
    },
    /**
     * Editing own Transport Cloud shipment plans
     */
    EDIT_SHIPMENT_PLANS_OWNER: {
      name: 'MODULE_TRANSPORT_CLOUD_EDIT_SHIPMENT_PLANS_OWNER',
    },
    /**
     * Editing all Transport Cloud columns
     */
    EDIT_COLUMNS_ALL: { name: 'MODULE_TRANSPORT_CLOUD_EDIT_COLUMNS_ALL' },
    /**
     * Editing Transport cloud columns for forwarder
     */
    EDIT_COLUMNS_FORWARDER: {
      name: 'MODULE_TRANSPORT_CLOUD_EDIT_COLUMNS_FORWARDER',
    },
    /**
     * Editing Transport Cloud columns for transport
     */
    EDIT_COLUMNS_TRANSPORT: {
      name: 'MODULE_TRANSPORT_CLOUD_EDIT_COLUMNS_TRANSPORT',
    },
    /**
     * Deleting all Transport Cloud records
     */
    DELETE_RECORDS_ALL: { name: 'MODULE_TRANSPORT_CLOUD_DELETE_RECORDS' },
    /**
     * Deleting own Transport Cloud records
     */
    DELETE_RECORDS_OWNER: {
      name: 'MODULE_TRANSPORT_CLOUD_DELETE_RECORDS_OWNER',
    },
    /**
     * Deleting all Transport Cloud shipment plans
     */
    DELETE_SHIPMENT_PLANS: {
      name: 'MODULE_TRANSPORT_CLOUD_DELETE_SHIPMENT_PLANS',
    },
    /**
     * Deleting own Transport Cloud shipment plans
     */
    DELETE_SHIPMENT_PLANS_OWNER: {
      name: 'MODULE_TRANSPORT_CLOUD_DELETE_SHIPMENT_PLANS_OWNER',
    },
    /**
     * Adding Transport Cloud shipment plans
     */
    ADD_SHIPMENT_PLANS: { name: 'MODULE_TRANSPORT_CLOUD_ADD_SHIPMENT_PLANS' },
    /**
     * Managing container statuses in Transport Cloud
     */
    MANAGE_CONTAINER_STATUSES: {
      name: 'MODULE_TRANSPORT_CLOUD_MANAGE_CONTAINER_STATUSES',
    },
    /**
     * Managing drivers database in Transport Cloud
     */
    MANAGE_DRIVERS_DATABASE: {
      name: 'MODULE_TRANSPORT_CLOUD_MANAGE_DRIVERS_DATABASE',
    },
  },

  /**
   * Dummy role to disable certain parts of GUI
   */
  DENY_ALL: { name: 'DENY_ALL' },
};
